const commands = {
  '/help': () => [
    'PORTFOLIO TERMINAL - COMMAND REFERENCE',
    '======================================',
    '',
    'Navigation Commands:',
    '  /gui        - Launch Windows 98 GUI interface',
    '  /about      - Display personal information',
    '  /skills     - List technical skills',
    '  /projects   - Show current desktop project inventory',
    '  /contact    - Display contact information',
    '',
    'System Commands:',
    '  /clear      - Clear terminal screen',
    '  /help       - Show this help message',
    '  /exit       - Return to boot screen',
    '  /skip       - Skip to GUI (same as /gui)',
    '',
    'Desktop Notes:',
    '  Each project now opens as its own icon/window in the GUI.',
    '  Use /gui if you want the full retro desktop experience.'
  ],
  '/gui': () => 'LAUNCH_GUI',
  '/skip': () => 'LAUNCH_GUI',
  '/about': () => [
    '=====================================',
    '           USER PROFILE v1.3         ',
    '=====================================',
    '',
    'Name: Fernando Murra Vicario',
    'Title: Full Stack Developer',
    'Location: San Antonio, TX',
    'Focus: Software Development, Cybersecurity, Data',
    '',
    'Bio: I like building useful products with a bit of',
    'personality. This portfolio uses a retro OS shell,',
    'but the goal is simple: show how I build and think.',
    '',
    'Type "/gui" to open the desktop version.'
  ],
  '/skills': () => [
    'TECHNICAL SKILLS DATABASE',
    '=========================',
    '',
    '[PROGRAMMING LANGUAGES]',
    '  Java................. [██████████░░] Advanced',
    '  Python............... [██████████░░] Skilled',
    '  TypeScript........... [█████████░░░] Intermediate',
    '  JavaScript........... [█████████░░░] Intermediate',
    '',
    '[FRAMEWORKS & LIBRARIES]',
    '  React................ [█████████░░░] Intermediate',
    '  Node.js.............. [███████████░] Skilled',
    '  Express.............. [████████░░░░] Intermediate',
    '  HTML/CSS............. [██████████░░] Skilled',
    '',
    '[TOOLS]',
    '  Git, Docker, AWS, Linux, Postman, VS Code',
    '',
    'Type "/gui" for the visual skills window.'
  ],
  '/projects': () => [
    'PROJECT REPOSITORY',
    '==================',
    '',
    '[1] GroupChat',
    '    Real-time chat room over WebSockets',
    '    Tech: Python, Flask, Flask-SocketIO',
    '    Status: ACTIVE',
    '',
    '[2] Genie Chrome Extension',
    '    LinkedIn profile -> personalized cold email in Gmail',
    '    Tech: JavaScript, Chrome MV3, Gemini API, Render',
    '    Status: MAINTAINED',
    '',
    '[3] Super Mario DQN',
    '    DQN agent learning Mario 1-1 from raw pixels',
    '    Tech: Python, PyTorch, TorchRL, OpenAI Gym',
    '    Status: RESEARCH',
    '',
    '[4] Book Review (Marginalia)',
    '    Search books, rate and review, personal shelf',
    '    Tech: Next.js 14, React, Supabase, Tailwind',
    '    Status: ACTIVE',
    '',
    '[5] Heat Map (CityPulse)',
    '    U.S. metro migration map from IRS data',
    '    Tech: React, Leaflet, Supabase, Recharts, Python ETL',
    '    Status: ACTIVE',
    '',
    '[6] ESG Pipeline',
    '    NLP/ML ESG scoring + greenwashing detection',
    '    Tech: Python, Streamlit, scikit-learn, NLTK, Plotly',
    '    Status: PIPELINE',
    '',
    'Type "/gui" to open each one as its own desktop icon.'
  ],
  '/contact': () => [
    'CONTACT INFORMATION',
    '===================',
    '',
    'Email: fmuvic13@gmail.com',
    'LinkedIn: linkedin.com/in/fernando-murra-vicario-/',
    'GitHub: github.com/F-MurraVicario13',
    'Resume: available from the GUI desktop',
    '',
    'Type "/gui" for interactive contact options.'
  ],
  '/clear': () => 'CLEAR',
  '/exit': () => 'EXIT'
};

export default commands;
